import { render, staticRenderFns } from "./StoreItemize.vue?vue&type=template&id=59806ec4"
import script from "./StoreItemize.vue?vue&type=script&lang=js"
export * from "./StoreItemize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports